var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3000px",
    height: "3000px",
    viewBox: "0 0 3000 3000",
    style: {
      enableBackground: "new 0 0 3000 3000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#999999;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#212121;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.7,152.6h2774v2774h-2774L152.7,152.6L152.7,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.9,116.9h2766.2v2766.2H116.9V116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2890.6,2890.6H109.4V109.4h2781.2L2890.6,2890.6L2890.6,2890.6z M124.4,2875.6h2751.2V124.4H124.4V2875.6z M2890.6,306.7 H109.4V109.4h2781.2L2890.6,306.7L2890.6,306.7z M124.4,291.7h2751.2V124.4H124.4V291.7z M2890.6,2890.6H109.4v-298.4h2781.2 L2890.6,2890.6L2890.6,2890.6z M124.4,2875.6h2751.2v-268.4H124.4V2875.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.9,116.9h2766.2v182.3H116.9V116.9z M232.5,2698.7h-15v85.4h15V2698.7z M267.7,2733.9h-85.4v15h85.4 V2733.9z M2752,2802.9c-33.9,0-61.5-27.6-61.5-61.5s27.6-61.5,61.5-61.5s61.5,27.6,61.5,61.5S2785.9,2802.9,2752,2802.9z  M2752,2694.9c-25.6,0-46.5,20.9-46.5,46.5s20.9,46.5,46.5,46.5s46.5-20.9,46.5-46.5S2777.6,2694.9,2752,2694.9z M2732,2722.3 c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9s-6.9-3.1-6.9-6.9S2728.2,2722.3,2732,2722.3z M2772.2,2722.3c3.8,0,6.9,3.1,6.9,6.9 s-3.1,6.9-6.9,6.9s-6.9-3.1-6.9-6.9S2768.4,2722.3,2772.2,2722.3z M2772,2762.7c5.4-5.5,5.5-12,5.5-12.8l-10,0.1 c0,1.6-1,9.7-15.7,9.7c-16.2,0-17.1-8.8-17.1-9.8v0.1h-10c0,0.2,0.3,19.7,27.1,19.7C2760.6,2769.7,2767.4,2767.3,2772,2762.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2537.4,201h-71.9v15h71.9V201z M2804.3,233.4l-60.4-60.3l-10.6,10.6l60.4,60.3L2804.3,233.4z M2804.3,183.7 l-10.6-10.6l-60.4,60.3l10.6,10.6L2804.3,183.7z M2666.6,245H2595v-73h71.6V245z M2610,230h41.6v-43H2610V230z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.7d20ab0aa7e4527124b7dc51700ffd3f.svg";
export { ForwardRef as ReactComponent };